import React, { useEffect, useState } from "react";
import Menu from "./Menu";
import { updateFullScreenLoader } from "../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import { http } from "../../helpers/http";
import { useParams } from "react-router-dom";
import { updateRestaurantInfo } from "../../redux/actions/restaurantActions";
import GoogleMapIFrame from "../common/GoogleMapIFrame";
import AddCartItem from "../modals/AddCartItem";
import Restaurant from "./Restaurant";
import Onboarding from "../header/Onboarding";
import { placeholderHandler } from "../../helpers/help";


function RestaurantData() {
  const restaurantInfo = useSelector((state) => state?.restaurant.info);
  const dispatch = useDispatch();
  let { outletId } = useParams();
  const [menu, setMenu] = useState();
  outletId = +outletId
  const restaurantDetails = (type) => {
    dispatch(updateFullScreenLoader(true));
    http(
      {
        method: "GET",
        url: `listMenu/${outletId}`,
        isSecure: true,
        // body: {
        //   outletId,
        // },
      },
      (res) => {

        setMenu(res)
        dispatch(updateRestaurantInfo(res));
        dispatch(updateFullScreenLoader(false));
      }
    );
  };
  useEffect(() => {
    restaurantDetails();
  }, []);

  return (
    <>
      <Onboarding />
      <div className="restaurantsNear_menu restaurantsNear_menu-copy">
        <div className="restro-details-container">
          <div className="tabResMenu">
            <div className="tabContainer">
              {/* <div className="res_img restro-menu">
                <img
                  onError={placeholderHandler}
                  src={menu?.image}
                  alt="restaurant"
                  className="restaurant-img w-100 exHgt"
                />
              </div> */}
              <div className="resto_img_section rest_mt">
                <img
                  onError={placeholderHandler}
                  src={menu?.image}
                  alt="restaurant"
                  className="resto_img_section-img exHgt"
                />
              </div>
            </div>
          </div>

          <h3 className="head3 mb-0 text-break">{restaurantInfo?.outlet_name}</h3>
          <div className="view_data_resaurant">

            <Menu menuImg={menu?.image}/>
          </div>
          <AddCartItem outletId={outletId} />
        </div>
      </div>

    </>
  );
}

export default RestaurantData;
